<div class="offcanvas-header">
  <h4 class="offcanvas-title">{{ title }}</h4>
  <button type="button" class="btn-close" (click)="onClickClose()"></button>
</div>
<div class="offcanvas-body">
  @for (field of fields; track field.name) {
    <div class="mb-3">
      <div class="text-uppercase text-muted fw-semibold mb-1">
        {{ field.title }}
      </div>
      <div>
        @switch (field.type) {
          @case ('badge') {
            <app-badge
              [message]="row?.[field.name]"
              [color]="row?.[field.color]"
            ></app-badge>
          }
          @case ('success-badge') {
            <app-success [isSuccessInput]="row?.[field.name]" />
          }
          @case ('display-like-code') {
            <app-display-like-code [value]="row?.[field.name]"></app-display-like-code>
          }
          @case ('display-like-quote') {
            <app-display-like-quote [value]="row?.[field.name]"></app-display-like-quote>
          }
          @default {
            {{ format(field) }}
          }
        }
      </div>
    </div>
  }
</div>
